import React from 'react';
import { useDispatch } from "react-redux";
import { Avatar, Dialog, DialogTitle, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import PersonIcon from '@material-ui/icons/Person';
import { green, deepOrange } from "@material-ui/core/colors";
import { seleccionAfiliado } from '../../../actions/afiliado';
import { changeStepper } from '../../../actions/preAfiliado/stepper';


export const ModalFamiliares = ({open, idAfiliado, grupoFamiliar, handleClose}) => {
    const dispatch = useDispatch();

    const handleSeleccionarAfiliado = (afiliado) => {
        if (!!afiliado){
          dispatch(seleccionAfiliado(afiliado));
          dispatch(changeStepper(1));
        }
        handleClose();
      };

    return ( 
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle style={{paddingBottom: 5}}>Seleccione el familiar</DialogTitle>
            <List sx={{ pt: 0 }} style={{padding: 15}}>
                {grupoFamiliar.filter(s => s.id_afiliado !== idAfiliado).map((familiar) => (
                <ListItem button onClick={() => handleSeleccionarAfiliado(familiar)} disabled={familiar.fecha_baja} key={familiar.id_afiliado}>
                    <ListItemAvatar>
                        <Avatar style={familiar.fecha_baja ? { backgroundColor: deepOrange[100], color: deepOrange[600] } : { backgroundColor: green[100], color: green[600] }}>
                            <PersonIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={familiar.apellido_y_nombre} />
                </ListItem>
                ))}
            </List>
        </Dialog>
     );
}